import { FC, PropsWithChildren } from 'react';
import { Text } from '@bridebook/aura';

interface IProps extends PropsWithChildren {}

export const RsvpError: FC<IProps> = ({ children }) => (
  <Text variant="typo-xs-semibold" className="text-alerts">
    {children}
  </Text>
);
